import React from 'react';

import './css/Input.css';

const Input = (props) => {
  const {
    onChange,
    type,
    id,
    name,
    value,
    labelText,
    defaultValue,
    defaultChecked,
  } = props;

  return (
    <>
      <input
        type={type}
        id={id}
        name={name}
        defaultChecked={defaultChecked}
        value={value}
        defaultValue={defaultValue}
        onChange={onChange}
      />
      <label htmlFor={id}>{labelText}</label>
    </>
  )
};

export default Input;
